module.exports = __webpack_public_path__ + "img/iconos-categorias-05.40917247.svg";